import React, { useState } from 'react';

// Renders a row's immutable human-readable trace-back code (e.g. "C202607120001":
// O=order, C=crypto, F=fiat, B=blockchain, then YYYYMMDD, then the day's 4-digit
// sequence). Assigned once at creation server-side and never changes, so it's a
// stable handle for referring to any order/transaction later.
//
// Click to copy — handy for pasting a code into a message/spreadsheet when
// tracing something back. onClick stops propagation so it never triggers a
// surrounding clickable row/card. Renders nothing when the row has no code
// (e.g. customer-ledger rows that aren't part of the O/C/F/B scheme), so it's
// safe to drop into any list.
//   <ReferenceTag value={row.reference_no} />
export default function ReferenceTag({ value, className, style, title }) {
  const [copied, setCopied] = useState(false);
  if (!value) return null;

  const copy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 1200); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(done).catch(() => {});
    } else {
      try {
        const ta = document.createElement('textarea');
        ta.value = value;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (err) { /* clipboard unavailable — ignore */ }
    }
  };

  return (
    <span
      onClick={copy}
      title={title || (copied ? 'Copied!' : `Reference ${value} — click to copy`)}
      className={className}
      style={{
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: '0.72rem',
        letterSpacing: '0.02em',
        color: copied ? '#1a7f37' : '#6b7280',
        background: copied ? 'rgba(26,127,55,0.10)' : 'rgba(107,114,128,0.10)',
        padding: '1px 5px',
        borderRadius: '4px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        userSelect: 'all',
        ...style,
      }}
    >
      {copied ? '✓ copied' : value}
    </span>
  );
}
